<template>
	<div class="title-wrapper">
		<div class="title-container">
			<div class="title-content has-text-centered">
				<h1 class="title">
					{{ name ? name : 'Contextualisation des lignes du temps' }}
				</h1>
				<p>
					{{ description }}
				</p>
				<div>
					<div class="columns is-centered is-multiline" style="margin-top: 20px;">
						<div class="column is-5" v-for="timeline in timelines" :key="timeline.id">
							<div class="box" :class="'has-background-' + timeline.color" style="position: relative; padding: 0.75rem; height: 140px;">
								<div class="media">
                                	<figure class="media-left" v-if="timeline.avatar" style="margin-right: 20px;">
										<p class="image" style="width: 96px; height: 96px;">
                                        	<img :src="timeline.avatar.url" style="box-shadow: none;">
                                    	</p>
                                	</figure>
                                	<div class="media-content">
                                		<p>
                                    		<b class="has-text-white" style="font-size: 110%; max-width: 40ch;margin-bottom: 5px;">{{ timeline.title }}</b>
                                    	</p>
                                    	<p class="has-text-white" style="font-size: 95%;">
                                        	{{ timeline.description }}
                                    	</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['name', 'description', 'timelines'],

		created() {

		}
	}
</script>

<style scoped>
	.title-wrapper {
		display: flex;
		flex-direction: row;
		flex-grow: 1;
		margin-left: 67px;
		margin-right: 67px;
	}

	.title-avatar {
		display: flex;
		flex: 1;
		align-items: center;
		justify-content: center;
	}

	.image img {
		border: 5px solid #fff;
		-webkit-box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.6);
		box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.6);
		max-width: 40vw;
		max-height: 40vh;
		width: inherit;
		height: inherit;
		background: #fff;
	}

	.title-container {
		display: flex;
		flex: 1;
		align-items: center;
		justify-content: center;
	}

	.title-content {
		text-align: left;
		padding-left: 25px;
		padding-right: 25px;
		width: 100%;
	}
</style>